import { LoginFormValues } from '../types';

export const INITIAL_VALUES: LoginFormValues = {
  username: '',
  password: '',
  app_url: undefined,
};

export const ACCEPTED_VALUES = ['en', 'es_US'];

export const UPDATE_PASSWORD_ERROR_CODE = 'password_needs_update';

export const LOGIN_QUERY_KEY = ['login'] as const;
export const LOGON_NEW_QUERY_KEY = ['logon', 'new'] as const;
export const LOGON_QUERY_KEY = ['logon'] as const;
